import { LeftOutlined } from '@ant-design/icons'
import useViewport from '@shared/innmaxLib/hooks/useViewport'
import { Drawer } from '@shared/innmaxUI'
import { Skeleton } from '@shared/innmaxUI/Loading'
import React from 'react'
import { useHistory } from 'react-router-dom'

export interface IMobilePageDrawerProps {
  open?: boolean
  onClose?: () => void
  children: React.ReactNode
  title?: string
  loading?: boolean
  contentClassName?: string
}

const MobilePageDrawer = (props: IMobilePageDrawerProps) => {
  const {
    open,
    onClose,
    children,
    title,
    loading = false,
    contentClassName = '',
  } = props

  const { isMobile } = useViewport()
  const history = useHistory()

  const drawerKey = React.useMemo(
    () => `drawer_${new Date().getTime().toString()}`,
    []
  )

  const prevUrlRef = React.useRef<string | null>(null)

  React.useEffect(() => {
    if (open) {
      prevUrlRef.current = `${history.location.pathname}${history.location.search}`
      const _search = new URLSearchParams(history.location.search)
      _search.set('openedDrawer', drawerKey)
      history.push({
        search: _search.toString(),
      })
    } else {
      const _search = new URLSearchParams(history.location.search)
      if (_search.get('openedDrawer') === drawerKey) {
        history.goBack()
      }
    }
  }, [open, drawerKey])

  React.useEffect(() => {
    const unlisten = history.listen((location, action) => {
      const url = `${location.pathname}${location.search}`
      if (url === prevUrlRef.current && action === 'POP') {
        onClose?.()
      }
    })
    return () => {
      unlisten()
    }
  }, [])

  return isMobile ? (
    <Drawer
      open={open}
      title=""
      closable={false}
      width={'100%'}
      push={false}
      bodyStyle={{
        padding: 0,
      }}
      drawerStyle={{
        background: '#272727',
      }}
      headerStyle={{
        border: '0',
      }}
      placement="right"
      onClose={() => {
        onClose?.()
      }}>
      <div className="flex gap-15 items-center p-18 pb-0 text-primary text-2xl">
        <LeftOutlined
          className="text-primary text-2xl"
          onClick={() => onClose?.()}
        />
        {title && <span>{title}</span>}
      </div>
      <div className={contentClassName ? contentClassName : `p-24`}>
        {loading ? (
          <div>
            <Skeleton length={1} />
          </div>
        ) : (
          children
        )}
      </div>
    </Drawer>
  ) : (
    <>{children}</>
  )
}

export default MobilePageDrawer
